import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { HeaderMenuStyles } from "./HeaderMenuStyles";
import {
  CLOSE,
  LOGOUT,
  MENU,
  MY_TASKS_LOWER,
  VIEW_COMMISSION_LOWER,
  VIEW_CUSTOMER_LOWER,
  VIEW_DASHBOARD_LOWER,
  VIEW_DOCUMENTS_LOWER,
  VIEW_HIERARCHY_LOWER,
  VIEW_PAYMENTS_LOWER,
  VIEW_POLICY_LOWER,
  VIEW_SETTINGS_LOWER,
  VIEW_UNDERWRITER_LOWER,
} from "../../constants";
import crossIcon from "../../assets/svgs/cross-icon.svg";
import {
  comingSoonAgentMenuItems,
  menuItems,
} from "../../constants/MobileMenu";
import ImageAndText from "../ImageAndText/ImageAndText";
import logoutIcon from "../../assets/svgs/logout-icon.svg";
import { useNavigate } from "react-router-dom";
import { agentLogout } from "../Login/agentAuthActions";
import { useAppDispatch } from "../../store/hooks";
import { getCookie } from "../../utils/Utility";
import CampaignIcon from "@mui/icons-material/Campaign";

type MenuItemType = {
  image: string;
  text: string;
  action: string;
  key: string;
};

type HeaderMenuProps = {
  onClose: () => void;
};

const HeaderMenu: React.FC<HeaderMenuProps> = ({ onClose }) => {
  const [hovered, setHovered] = React.useState(false);
  const [logOutHover, setLogOutHover] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const producerTypeCd = getCookie("producerTypeCd");

  const handleClick = (action: string) => {
    switch (action) {
      case MY_TASKS_LOWER:
        navigate("/agent/mytasks");
        break;
      case VIEW_DASHBOARD_LOWER:
        navigate("/agent/dashboard");
        break;
      case VIEW_HIERARCHY_LOWER:
        navigate("/agent/hierarchy");
        break;
      case VIEW_POLICY_LOWER:
        navigate("/agent/policyListing");
        break;
      case VIEW_CUSTOMER_LOWER:
        navigate("/agent/customerListing");
        break;
      case VIEW_COMMISSION_LOWER:
        navigate("/agent/commissionStatements");
        break;
      case VIEW_PAYMENTS_LOWER:
        navigate("/agent/paymentSchedule");
        break;
      case VIEW_DOCUMENTS_LOWER:
        navigate("/agent/documentListing");
        break;
      case VIEW_UNDERWRITER_LOWER:
        navigate("/agent/underwriter");
        break;
      case VIEW_SETTINGS_LOWER:
        console.log("Navigating to Settings");
        break;
      default:
        navigate("/agent");
        break;
    }
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleAgentLogout = async () => {
    try {
      const date = new Date().toString();
      const logoutRequestBody = {
        logoutTime: date,
      };
      await dispatch(agentLogout(logoutRequestBody));
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Logout failed. Please try again.");
    }
  };

  const filteredMenuItems =
    producerTypeCd === "Producer"
      ? menuItems.filter((item) => item.key !== "hierarchy")
      : menuItems;

  return (
    <Box sx={HeaderMenuStyles.menuContainer}>
      <Box sx={HeaderMenuStyles.headingContainer}>
        <Typography sx={HeaderMenuStyles.headingText}>{MENU}</Typography>
        <Box sx={HeaderMenuStyles.imageContainer} onClick={onClose}>
          <Box sx={HeaderMenuStyles.crossIcon}>
            <img src={crossIcon} alt={CLOSE} />
          </Box>
        </Box>
      </Box>
      <Box sx={HeaderMenuStyles.linksContainer}>
        <Box sx={HeaderMenuStyles.navigationContainer}>
          {filteredMenuItems.map((item: MenuItemType, index: number) => (
            <Box
              key={item.key}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <ImageAndText
                key={item.key}
                image={item.image}
                text={item.text}
                onClick={() => handleClick(item.action)}
                additionalClassName={HeaderMenuStyles.imageTextContainer}
                additionalClassText={
                  hovered
                    ? HeaderMenuStyles.imageHoverText
                    : HeaderMenuStyles.imageText
                }
                imageClassName={HeaderMenuStyles.image}
              />
            </Box>
          ))}
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                paddingX: "1rem",
              }}
            >
              <CampaignIcon
                sx={{
                  fill: "#FFAC1C",
                  fontSize: "40px",
                }}
              />
              <Typography
                textAlign="center"
                variant="h6"
                sx={{
                  color: "#FFAC1C",
                  fontWeight: "bold",
                  fontStyle: "italic",
                }}
              >
                Coming Soon
              </Typography>
            </Box>
            <Box>
              {comingSoonAgentMenuItems.map(
                (item: MenuItemType, index: number) => (
                  <Box
                    key={item.key}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                  >
                    <ImageAndText
                      key={item.key}
                      image={item.image}
                      text={item.text}
                      additionalClassName={{
                        ...HeaderMenuStyles.imageTextContainer,
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                      imageClassName={HeaderMenuStyles.image}
                      onClick={() => handleClick(item.action)}
                    />
                  </Box>
                )
              )}
            </Box>
          </Box>
        </Box>
        <Box
          sx={HeaderMenuStyles.logOutContainer}
          onMouseEnter={() => setLogOutHover(true)}
          onMouseLeave={() => setLogOutHover(false)}
        >
          <ImageAndText
            image={logoutIcon}
            text={LOGOUT}
            onClick={handleAgentLogout}
            additionalClassName={HeaderMenuStyles.imageTextContainer}
            additionalClassText={
              logOutHover
                ? HeaderMenuStyles.imageHoverText
                : HeaderMenuStyles.imageText
            }
            imageClassName={HeaderMenuStyles.image}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderMenu;
